import _ from 'lodash';
import qs from 'querystringify';

import { postJSON, getJSON } from 'api/_helpers';

export async function createCanvas(canvasObject) {
  const response = await postJSON('/canvas', canvasObject);
  return await response.json();
}

export async function fetchCanvas(id, edit) {
  const filteredParams = _.pickBy({ id, edit }, _.identity);
  return await getJSON(`/canvas?${qs.stringify(filteredParams)}`);
}

export async function listCanvas() {
  return await getJSON(`/canvas/list`);
}



// WEBPACK FOOTER //
// ./src/api/canvas.js